import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { useAuthStore } from "@/stores/auth";

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((state) => state.token);
  return <QueryClientProvider key={token ?? "anonymous"} client={queryClient}>
    {children}
  </QueryClientProvider>;
}
